import * as React from 'react';
import * as styles from './styles.css';
import { IGetFiltersResponseV2Schema } from '../../common/repositories/job-vacancies-backend/entities/filters/GetFiltersResponseV2Schema';
import { Tag } from '../Tag';
import { ReactNode, useState } from 'react';
import { IVacanciesFiltersV2Schema } from '../../common/repositories/job-vacancies-backend/entities/filters/VacanciesFiltersV2Schema';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import { Typography } from '../Typography';
import { Combobox } from '../Combobox';
import { ResetFiltersModal } from './components';

interface IFilterLayoutProps {
  filters?: IGetFiltersResponseV2Schema;
  handleSelect: (filterName: string, selectedOptions: string[]) => void;
  control?: ReactNode;
  handlePress: (isPressed: boolean, value: string) => void;
  selectedFilters: IVacanciesFiltersV2Schema;
  handleReset: (filterName?: string) => void;
}

export const FiltersLayout: React.FC<IFilterLayoutProps> = ({
  control,
  filters,
  handleSelect,
  handlePress,
  selectedFilters,
  handleReset,
}) => {
  const deviceType = useDeviceType();
  const [isConfirmResetShowed, setConfirmResetShowed] = useState(false);

  if (!filters) {
    return null;
  }

  const handleResetWithConfirm = () => {
    return deviceType === 'desktop' ? handleReset() : setConfirmResetShowed(true);
  };

  const handleConfirmReset = () => {
    handleReset();
    setConfirmResetShowed(false);
  };

  return (
    <div className={cn(styles['filters-layout'], styles[deviceType])}>
      <div className={cn(styles['header'], styles[deviceType])}>
        <Typography.Title level={deviceType === 'desktop' ? 2 : 5} color="primary">
          Присоединяйся к команде мечты
        </Typography.Title>
      </div>
      <div className={cn(styles['filters'], styles[deviceType])}>
        {filters.filters.map(filter => {
          return (
            <div className={styles.filter} key={filter.name}>
              <Combobox
                name={filter.name}
                label={filter.label}
                isMultiselect={filter.multiselect}
                options={filter.options}
                handleSelect={handleSelect}
                selectedOptions={selectedFilters[filter.name as keyof IVacanciesFiltersV2Schema]}
                handleReset={handleReset}
              />
            </div>
          );
        })}
      </div>
      <div className={cn(styles['bottom-filters'], styles[deviceType])}>
        <div className={cn(styles['tags'], styles[deviceType])}>
          {filters.tagFilters.map(tag => {
            return (
              <Tag
                key={tag.value}
                onChange={handlePress}
                pressed={selectedFilters.tags?.includes(tag.value)}
                text={tag.label}
                id={tag.value}
              />
            );
          })}
        </div>
        {control && (
          <div className={styles['control']} onClick={handleResetWithConfirm}>
            {control}
          </div>
        )}
      </div>
      <ResetFiltersModal
        handleClose={() => setConfirmResetShowed(false)}
        isOpen={isConfirmResetShowed}
        handleConfirm={handleConfirmReset}
      />
    </div>
  );
};
